import { usePage } from "@inertiajs/react";

import { GROUPS } from "@/constants/groups";
import type { SharedData } from "@/types";

export function useResourcePermissions(resource: {
  can_update?: boolean;
  status: string
}) {
  const shared = usePage().props as unknown as SharedData;
  const userGroups = shared.auth?.groups ?? [];

  return {
    isSupervisor: userGroups.includes(GROUPS.supervisor),
    isBuyer: userGroups.includes(GROUPS.buyer),
    canEdit: (resource.can_update ?? false) && resource.status !== "processing",
  };
}